import React from "react";
import './utilStyles/YellowDivider.scss'

export const YellowDivider = () => {

    return (
        <div id="yellow-divider"></div>
    )
}